// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"781":"0c73eee2","902":"8dd8b80e"}[chunkId] + ".chunk.css";
};